module.exports = __webpack_public_path__ + "static/media/header.36332cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/header/header.png
// module id = 793
// module chunks = 0